<template>
    <simple-pager 
            :current-page="pagination.current_page" 
            :last-page="pagination.last_page"
            @navigate="$emit('navigate', $event)"
    ></simple-pager>
</template>

<script>
    import SimplePager from '@/components/Lists/SimplePager'
    
    export default {
        components: {SimplePager},
        
        props: {'pagination': {}}
    }
</script>
